import {RESPONSE_STATUSES, REST_METHODS} from '@/src/app/constants/api';
import {
  getAuthorizationToken,
  STORAGE_KEY,
} from '@/src/app/utils/authorizationToken';
import nextServerFetch from '@/src/app/utils/nextServerFetch';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

const signInUser = async (values) => {
  // @ts-ignore
  const {status, responseBody} = await unauthorizedFetch({
    method: REST_METHODS.POST,
    path: `/api/v1/auth/sign_in`,
    body: {
      user: values,
    },
    shouldSkipUnauthorizedStatus: true,
  });

  if (status === RESPONSE_STATUSES.SUCCESS) {
    await nextServerFetch({
      method: REST_METHODS.POST,
      path: '/api/cookies',
      body: {
        name: STORAGE_KEY,
        value: getAuthorizationToken(),
      },
    });
  }

  return {
    status,
    responseBody,
  };
};

export default signInUser;
